var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spuInfo && _vm.goodsType != 3)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
    act: 'show',
    params: {
      cfrom: '178|001|02|077',
      event_id: '178|001|02|077',
      page_name: 1,
      ignoreShowTrack: _vm.ignoreShowTrack,
      sku_id: _vm.skuId
    }
  }),expression:"{\n    act: 'show',\n    params: {\n      cfrom: '178|001|02|077',\n      event_id: '178|001|02|077',\n      page_name: 1,\n      ignoreShowTrack,\n      sku_id: skuId\n    }\n  }"}],staticClass:"detail-infos",attrs:{"id":"detailInfos"}},[_c('v-list-view',{attrs:{"name":"已选","right-icon":"arrow-right-v3"},on:{"click":_vm.showSelect}},[_c('div',{staticClass:"content"},_vm._l((_vm.checkTxt),function(item){return _c('span',{key:item,staticClass:"content-item"},[_c('span',[_vm._v(_vm._s(item))])])}),0)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }